type RackSectionStructure = {
  name: string;
  alt: string;
  src: string;
  href: string;
};

const STORAGE_URL =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/racks';

export const RACK_SECTION_DATA: RackSectionStructure[] = [
  {
    name: 'Дуб',
    alt: 'Стеллаж цвета Дуб',
    src: `${STORAGE_URL}/1.jpg/1.jpg`,
    href: '/catalogue/stellazhi-dlya-doma/stellazhi-v-cvete-dub/',
  },
  {
    name: 'Графит',
    alt: 'Стеллаж цвета Графит',
    src: `${STORAGE_URL}/2.jpg/2.jpg`,
    href: '/catalogue/stellazhi-dlya-doma/stellazhi-v-cvete-grafit/',
  },
  {
    name: 'Белый',
    alt: 'Стеллаж белого цвета',
    src: `${STORAGE_URL}/3.jpg/3.jpg`,
    href: '/catalogue/stellazhi-dlya-doma/stellazhi-v-cvete-belyy/',
  },
];
